/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 149.0.0-SNAPSHOT
 */

export type RoamingInfoUsageZone =
  (typeof RoamingInfoUsageZone)[keyof typeof RoamingInfoUsageZone];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoamingInfoUsageZone = {
  ZONE1: "ZONE1",
  ZONE2: "ZONE2",
  ZONE3: "ZONE3",
} as const;
